import { Button, Stack, Typography } from '@mui/material';
import { cloneDeep, concat, forOwn, get, set } from 'lodash';
import React, { FC } from 'react';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import GetRecord from 'src/lib/api/GetRecord';
import { APIS } from 'src/lib/constants/apis';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkReadOnlyInUeberarbeitung, getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import { getOrgaDateFuerAntrag } from 'src/utils/orgaDatenhelper';

// import Population
import POP_LEVEL from 'src/lib/api/Populations.json';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AntragstelerinGlobal: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleOrgaDatenUebernehmen = async () => {
		const orgaId = get(application, `${P.Antragstellende_Organisation.path}.id`, -1);
		if (orgaId) {
			let appCopy = cloneDeep(application);
			const orgaRes = await GetRecord(APIS.Organisation, orgaId, POP_LEVEL.organisation.FULL);
			const orgaOriginalData = removeNullDeep(removeDataKeys(orgaRes));
			const orgaDataFuerAntrag = getOrgaDateFuerAntrag(orgaOriginalData);
			// This lodash function loops throug a JSON.
			// The parmeter for the callback-function are (value, key)
			forOwn(orgaDataFuerAntrag, (value: string, key: string) => {
				if (key === getFieldNamefromDataPath(P.Antragstellende_Organisation_Ansprechpartnerin.path)) {
					if (get(appCopy, P.Antragstellende_Organisation_Ansprechpartnerin.path, []).length > 0) {
						// Do Nothing
						// Muss nichts nochmal übernommen werden
					} else {
						set(appCopy, `attributes.${key}`, value);
					}
				} else {
					set(appCopy, `attributes.${key}`, value);
				}
			});
			setApplicationProperty('attributes', get(appCopy, 'attributes'));
		}
	};
	return (
		<>
			<ApplicationHeading title='Antragstellende' description={PLATZHALTER_TEXT} />

			<Stack spacing={2} sx={{ mb: '1rem' }}>
				<MUIAlert
					title={'Hinweis:'}
					message={
						<>
							<Typography variant='body2' sx={{ mb: 2 }}>
								Wenn Sie die Daten Ihrer Organisation bearbeiten möchten, können Sie dies tun, indem Sie oben rechts auf "Ihren Namen →
								Organisationsprofil" klicken. Beachten Sie, dass ausschließlich Nutzerverwalter diese Informationen bearbeiten können. Durch
								einen Klick auf den nachfolgenden Button können diese Angaben dann in diesen Antrag übernommen werden. Wenn es weitere Anträge
								gibt, in denen die Daten aktualisiert werden müssen, dann müssen Sie dort ebenfalls mithilfe des Buttons die Daten
								aktualisieren.
							</Typography>
							<Button onClick={handleOrgaDatenUebernehmen} disabled={updatedReadOnly}>
								Daten aktualisieren
							</Button>
						</>
					}
				/>
			</Stack>

			<PruefAssistenz
				statusPath={P.Antragstellende_Pruefung_Pruefstatus.path}
				hinweisPath={P.Antragstellende_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Antragstellende_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Antragstellende_Pruefung_Erledigt.path}
				formStruc={formStruc(application)}
			/>
		</>
	);
};

export default AntragstelerinGlobal;

const formStruc = (_application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Antragstellende_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];

	return struc;
};

export const getFormStrucAntragstelerinGlobal = (application: any) => {
	let result: FormStrucItem[] = [];

	if (checkIfPruefAssitenzNeedsToValidate(application, P.Antragstellende_Pruefung_Pruefstatus.path, P.Antragstellende_Pruefung_Erledigt.path)) {
		result = concat(formStruc(application), result);
	}
	return result;
};
